import { LoggedInUserProfile } from 'models/LoggedInUserProfile';
import { getMyProfile } from 'api/services/user-service';
import useApiCall from 'hooks/useApiCall';
import { useCallback } from 'react';

export const useGetMyProfile = () => {
    const { callAPI, loading } = useApiCall<undefined, LoggedInUserProfile>(getMyProfile, undefined, undefined, true);

    const fetchProfile = useCallback(async () => {
        return await callAPI(undefined);
    }, [callAPI]);

    return { getMyProfile: fetchProfile, gettingMyProfile: loading };
};